import React from 'react';
import { useLocation } from 'react-router-dom';

import BackButton from '../../../sharedModules/layout/BackButton';

const ChillerBackButton = () => {
  const returnTo = new URLSearchParams(useLocation().search).get('return_to');

  let buttonLabel = 'Upcoming Jobs';
  let buttonLink = '/chiller_logs/search';

  if (returnTo === 'approvals') {
    buttonLabel = 'Approval Queue';
    buttonLink = '/chiller_logs/approvals';
  }

  return <BackButton buttonLabel={buttonLabel} buttonLink={buttonLink} />;
};

export default ChillerBackButton;
